<template>
 <b-card>
   <i class="fa fa-user-lock fa-lg mr-2 ml-2" aria-hidden="true"></i>
   <span class="h6">{{ $t('menu.reports.permissions') }}</span>
   <hr class="mt-1 mb-1">
   <b-row>
     <b-col cols="6">
       <b-form-group>
         <label for="user_select">{{ $t('views.permissionsreport.user') }}</label>
         <model-select id="user_select" v-model="selectedUserClientTypeId" :options="userOptions"></model-select>
       </b-form-group>
     </b-col>
     <b-col cols="6">
       <b-form-group>
         <label for="permission_type">{{ $t('views.permissionsreport.permissionType') }}</label>
         <model-select id="permission_type" v-model="selectedPermissionType" :options="permissionTypeOptions"></model-select>
       </b-form-group>
     </b-col>
     <b-col cols="4" v-if="selectedPermissionType === 0">
       <b-form-group>
         <label for="filter_permission">{{ $t('views.permissionsreport.searchPermissions') }}</label>
         <input v-model="filter" id="filter_permission" type="text" class="form-control">
       </b-form-group>
     </b-col>
     <b-col cols="12" v-if="selectedPermissionType === 0">
       <Loader v-if="isLoadingReport"></Loader>
       <span v-else-if="!isLoadingReport && userPermissions.length < 1">
         {{ $t('views.permissionsreport.noPermissions') }}
       </span>
       <table class="table table-sm table-gird" v-else>
         <thead>
         <tr>
           <th>{{ $t('views.permissionsreport.accessToViews') }}</th>
         </tr>
         </thead>
         <tbody>
         <tr v-for="(item, index) in userPermissions" :key="'permission-' + index">
           <td>
             {{ item.description }}
           </td>
         </tr>
         </tbody>
       </table>
     </b-col>
     <b-col cols="12" v-else-if="selectedPermissionType === 1 || selectedPermissionType === 2">
       <Loader v-if="isLoadingReport"></Loader>
       <table class="table table-sm table-gird" v-else>
         <thead>
         <tr>
           <th v-for="(header, index) in tableHeaders" :key="'header - ' + index">
             {{ header }}
           </th>
         </tr>
         </thead>
         <tbody>
         <tr v-for="(item, index) in Object.values(userPermissions)" :key="'task_permission-' + index">
           <td>
             {{ Object.keys(userPermissions)[index] }}
           </td>
           <td class="text-center"
               v-for="(permission, index) in item[Object.keys(item)[0]]['permissions']"
               :key="'permission-'+index"
           >
             <div v-html="getIcon(permission.value)"></div>
           </td>
         </tr>
         </tbody>
       </table>
     </b-col>
   </b-row>
 </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'List',
  components: {
    Loader,
    ModelSelect
  },

  data () {
    return {
      isLoadingReport: false,
      permissionTypeOptions: [
        {
          text: this.$t('views.permissionsreport.types.acl'),
          value: 0
        },
        {
          text: this.$t('views.permissionsreport.types.task'),
          value: 1
        },
        {
          text: this.$t('views.permissionsreport.types.case'),
          value: 2
        }
      ],
      tableHeaders: [
        this.$t('views.excmcasetype.show.title'),
        this.$t('views.excmtasktype.form.create'),
        this.$t('views.excmtasktype.form.read'),
        this.$t('views.excmtasktype.form.read2'),
        this.$t('views.excmtasktype.form.update'),
        this.$t('views.excmtasktype.form.delete'),
        this.$t('views.excmtasktype.form.accessFirm'),
        this.$t('views.excmtasktype.form.accessGroup'),
        this.$t('views.excmtasktype.form.accessSelf'),
        this.$t('views.excmtasktype.form.accessAll')
      ],
      selectedPermissionType: 0,
      selectedUserClientTypeId: '',
      filter: '',
      userDataSearchParams: {
        idClientType: [3, 5, 7, 8],
        pagination: false
      },
      userPermissionsSetter: []
    }
  },

  watch: {
    selectedUserClientTypeId (val) {
      this.getReport(val)
    },
    selectedPermissionType () {
      if (this.selectedUserClientTypeId) this.getReport(this.selectedUserClientTypeId)
    }
  },

  computed: {
    ...mapGetters({
      deletedItem: 'userdata/del/deleted',
      error: 'userdata/list/error',
      items: 'userdata/list/items',
      isLoading: 'userdata/list/isLoading',
      view: 'userdata/list/view'
    }),
    userOptions () {
      if (this.items.length < 1) return []
      return this.items.map(entry => {
        return {
          text: entry.fullName + ' - ' + entry.idClientType.title,
          value: getId(entry.idClientType['@id'])
        }
      })
    },
    userPermissions () {
      if (this.selectedPermissionType !== 0 || !this.filter) return this.userPermissionsSetter
      else {
        return this.userPermissionsSetter.filter(entry => {
          return entry.description.includes(this.filter)
        })
      }
    }
  },

  created () {
    this.getList()
  },

  methods: {
    getReport (clientTypeId) {
      switch (this.selectedPermissionType) {
        case 0:
          this.fetchPermissionReport(clientTypeId, 'acl')
          break
        case 1:
          this.fetchPermissionReport(clientTypeId, 'task')
          break
        case 2:
          this.fetchPermissionReport(clientTypeId, 'case')
          break
      }
    },
    getList () {
      let link = addParamsToQuery('user_datas', this.userDataSearchParams)
      this.getPage(link)
    },
    ...mapActions({
      getPage: 'userdata/list/default'
    }),
    getIcon (bool) {
      if (bool) {
        return '<i class="fa fa-check-circle fa-lg" style="color: #28a745"></i>'
      } else return '<i class="fa fa-times-circle fa-lg" style="color: #dc3545"></i>'
    },
    toggleLoadingReport () {
      this.isLoadingReport = !this.isLoadingReport
    },
    async fetchPermissionReport (clientTypeId, type) {
      this.toggleLoadingReport()
      this.userPermissionsSetter = await new ApiService(`client_type/${clientTypeId}/permissions_report/${type}`).getResults()
      this.toggleLoadingReport()
    }
  }
}
</script>

<style scoped>

</style>
